// components/Sidebar.jsx
import { Icons } from './UI';
import { STAGES } from '../utils/constants';

const TAB_ICONS = {
  stage:       '◈',
  draft:       '✦',
  exhibits:    '⊞',
  std215:      '📋',
  attachments: '⊡',
  amendments:  '⊕',
  emails:      '✉',
  vault:       '⊘',
  reminders:   '◎',
};

export default function Sidebar({
  view, setView, contract, contracts, tab, setTab,
  activeId, openContract, flushSaves, pendingReminders,
  loadedTotal, library, paal, profileComplete, onShowOnboarding, onAgencyAdmin,
  darkMode, setDarkMode, storageKb, cmsCount = 0, templatesCount = 0, onSignOut, onAdminDashboard, isAdmin = false,
  moduleConfig = null,
}) {
  const mod = (key) => !moduleConfig || moduleConfig[key] !== false;
  const contractTabs = [
    mod('stage')      && ['stage',       'Stage & Info',   null],
    mod('penny')      && ['draft',       'Penny',          null],
    mod('assembly')   && ['assembly',    'Assembly',       contract?.exhibits?.length || null],
    mod('std213')     && ['std213',      'STD 213',        null],
                         ['documents',   'Documents',      null],
    mod('amendments') && ['amendments',  'Amendments',     contract?.amendments?.length || null],
    mod('emails')     && ['emails',      'Emails',         null],
    mod('vault')      && ['vault',       'Vault',          null],
    mod('reminders')  && ['reminders',   'Reminders',      pendingReminders > 0 ? pendingReminders : null],
  ].filter(Boolean);

  function navTo(v) {
    flushSaves();
    setView(v);
  }

  return (
    <aside className="sidebar">
      <div className="sb-header">
        <div className="sb-logo-mark">
          <div className="sb-logo-icon" dangerouslySetInnerHTML={{ __html: '<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" width=\"100%\" height=\"100%\"><rect x=\"2\" y=\"13\" width=\"18\" height=\"6\" rx=\"3\" fill=\"url(#ab1)\"/><rect x=\"17\" y=\"14\" width=\"7\" height=\"4\" rx=\"2\" fill=\"url(#ab2)\"/><rect x=\"22\" y=\"14.5\" width=\"7\" height=\"3\" rx=\"1.5\" fill=\"url(#ab3)\"/><circle cx=\"4\" cy=\"16\" r=\"3.5\" fill=\"none\" stroke=\"#2A1200\" stroke-width=\"1.5\"/><circle cx=\"4\" cy=\"16\" r=\"2\" fill=\"url(#alens)\" opacity=\"0.85\"/><rect x=\"8\" y=\"13\" width=\"1.5\" height=\"6\" rx=\"0.5\" fill=\"url(#aband)\"/><rect x=\"14\" y=\"13\" width=\"1.5\" height=\"6\" rx=\"0.5\" fill=\"url(#aband)\"/><rect x=\"19\" y=\"14\" width=\"1\" height=\"4\" rx=\"0.4\" fill=\"url(#aband)\"/><line x1=\"24\" y1=\"14.8\" x2=\"24\" y2=\"17.2\" stroke=\"#1A0A00\" stroke-width=\"0.6\" opacity=\"0.5\"/><line x1=\"25.5\" y1=\"14.8\" x2=\"25.5\" y2=\"17.2\" stroke=\"#1A0A00\" stroke-width=\"0.6\" opacity=\"0.5\"/><defs><linearGradient id=\"ab1\" x1=\"0\" y1=\"0\" x2=\"0\" y2=\"1\"><stop offset=\"0%\" stop-color=\"#6B3A00\"/><stop offset=\"40%\" stop-color=\"#3D2000\"/><stop offset=\"100%\" stop-color=\"#1A0A00\"/></linearGradient><linearGradient id=\"ab2\" x1=\"0\" y1=\"0\" x2=\"0\" y2=\"1\"><stop offset=\"0%\" stop-color=\"#5A3000\"/><stop offset=\"50%\" stop-color=\"#3A1A00\"/><stop offset=\"100%\" stop-color=\"#1A0800\"/></linearGradient><linearGradient id=\"ab3\" x1=\"0\" y1=\"0\" x2=\"0\" y2=\"1\"><stop offset=\"0%\" stop-color=\"#4A2800\"/><stop offset=\"100%\" stop-color=\"#150700\"/></linearGradient><linearGradient id=\"aband\" x1=\"0\" y1=\"0\" x2=\"0\" y2=\"1\"><stop offset=\"0%\" stop-color=\"#7A4500\"/><stop offset=\"100%\" stop-color=\"#2A1000\"/></linearGradient><radialGradient id=\"alens\" cx=\"35%\" cy=\"30%\"><stop offset=\"0%\" stop-color=\"#4A7AB5\"/><stop offset=\"100%\" stop-color=\"#0A1F3D\"/></radialGradient></defs></svg>' }} />
          <div>
            <div className="sb-title">GoldenScope</div>
            <div className="sb-subtitle">CA State Contract Management</div>
          </div>
        </div>
      </div>

      <nav className="sb-nav">
        <div className="sb-section-label">Workspace</div>

        <div className={`sb-item ${view === 'dashboard' ? 'active' : ''}`} onClick={() => navTo('dashboard')}>
          <span className="sb-item-icon">⊟</span>
          <span className="sb-item-label">All Contracts</span>
          {contracts.length > 0 && <span className="sb-badge sb-badge-gold">{contracts.length}</span>}
        </div>

        {mod('analytics') && <div className={`sb-item ${view === 'analytics' ? 'active' : ''}`} onClick={() => navTo('analytics')}><span className="sb-item-icon">◈</span><span className="sb-item-label">Analytics</span></div>}

        {mod('archive') && <div className={`sb-item ${view === 'archive' ? 'active' : ''}`} onClick={() => navTo('archive')}><span className="sb-item-icon">📁</span><span className="sb-item-label">Archive</span></div>}

        <div className={`sb-item ${view === 'supervisor' ? 'active' : ''}`} onClick={() => navTo('supervisor')}>
          <span className="sb-item-icon">👁</span>
          <span className="sb-item-label">Supervisor</span>
        </div>

        {mod('vendor_library') && <div className={`sb-item ${view === 'vendors' ? 'active' : ''}`} onClick={() => navTo('vendors')}><span className="sb-item-icon">🏢</span><span className="sb-item-label">Vendor Library</span></div>}

        {contract && (
          <>
            <div className="sb-divider" style={{ margin: '8px 16px' }} />
            <div className="sb-section-label" style={{ fontSize: 8, color: 'var(--gold-500)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
              {(contract.title || 'Contract').slice(0, 22)}
            </div>

            {contractTabs.map(([t, lbl, cnt]) => (
              <div
                key={t}
                className={`sb-item ${view === 'contract' && tab === t ? 'active' : ''}`}
                onClick={() => { setView('contract'); setTab(t); }}
                style={{ paddingLeft: 20, fontSize: 12 }}
              >
                <span className="sb-item-icon" style={{ fontSize: 11 }}>{TAB_ICONS[t]}</span>
                <span className="sb-item-label">{lbl}</span>
                {cnt !== null && cnt > 0 && (
                  <span className={`sb-badge ${t === 'reminders' ? 'sb-badge-red' : 'sb-badge-gold'}`}>{cnt}</span>
                )}
              </div>
            ))}
          </>
        )}

        <div className="sb-divider" />
        <div className="sb-section-label">Configuration</div>

        <div className={`sb-item ${view === 'profile' ? 'active' : ''}`} onClick={() => navTo('profile')}>
          <span className="sb-item-icon">◉</span>
          <span className="sb-item-label">User Profile</span>
          {!profileComplete
            ? <span className="sb-badge sb-badge-warn">!</span>
            : <span className="sb-badge sb-badge-green">✓</span>
          }
        </div>

        {mod('paal') && <div className={`sb-item ${view === 'paal' ? 'active' : ''}`} onClick={() => navTo('paal')}><span className="sb-item-icon">⊡</span><span className="sb-item-label">PAAL & Authority</span>{!paal.uploaded && <span className="sb-badge sb-badge-warn">!</span>}</div>}

        {mod('library') && <div className={`sb-item ${view === 'library' ? 'active' : ''}`} onClick={() => navTo('library')}><span className="sb-item-icon">⊕</span><span className="sb-item-label">Reference Library</span>{loadedTotal > 0 ? <span className="sb-badge sb-badge-green">{loadedTotal}</span> : <span className="sb-badge sb-badge-warn">!</span>}</div>}

        {mod('cm_module') && <div className={`sb-item ${view === 'cms' ? 'active' : ''}`} onClick={() => navTo('cms')}><span className="sb-item-icon">◉</span><span className="sb-item-label">CM Roster</span>{cmsCount > 0 ? <span className="sb-badge sb-badge-gold">{cmsCount}</span> : <span className="sb-badge sb-badge-warn">!</span>}</div>}

        {mod('template_library') && <div className={`sb-item ${view === 'templates' ? 'active' : ''}`} onClick={() => navTo('templates')}><span className="sb-item-icon">⊟</span><span className="sb-item-label">Template Library</span>{templatesCount > 0 ? <span className="sb-badge sb-badge-gold">{templatesCount}</span> : <span className="sb-badge sb-badge-warn">!</span>}</div>}

        {isAdmin && (
          <div className={`sb-item ${view === 'settings' ? 'active' : ''}`} onClick={() => navTo('settings')}>
            <span className="sb-item-icon">⊘</span>
            <span className="sb-item-label">API & Settings</span>
          </div>
        )}

        {loadedTotal > 0 && (
          <div className="sb-lib-status">
            {Object.entries(library).filter(([,v]) => v).slice(0, 4).map(([k]) => (
              <div key={k} className="lib-pill">
                <div className="lib-pill-dot" />
                {k.replace('scm_', 'SCM ').replace('_', ' ')}
              </div>
            ))}
          </div>
        )}
      </nav>

      <div className="sb-footer">
        <div className="sb-storage-label" style={{ marginBottom: 4 }}>
          <span>Local storage</span>
          <span>{storageKb} KB used</span>
        </div>
        <div className="sb-storage-bar">
          <div className="sb-storage-fill" style={{ width: Math.min(100, (storageKb / 5000) * 100) + '%' }} />
        </div>
        <button
          onClick={() => setDarkMode(d => !d)}
          style={{
            marginTop: 10, background: 'none', border: '1px solid rgba(255,255,255,.1)',
            borderRadius: 6, color: 'var(--navy-300)', cursor: 'pointer',
            padding: '5px 10px', fontSize: 11, display: 'flex', alignItems: 'center', gap: 6, width: '100%',
          }}
        >
          {darkMode ? <Icons.sun /> : <Icons.moon />}
          {darkMode ? 'Light mode' : 'Dark mode'}
        </button>
        {onAdminDashboard && (
          <button
            onClick={onAdminDashboard}
            style={{
              marginTop: 6, background: 'rgba(196,153,34,.15)', border: '1px solid rgba(196,153,34,.3)',
              borderRadius: 6, color: 'var(--gold-400)', cursor: 'pointer',
              padding: '5px 10px', fontSize: 11, display: 'flex', alignItems: 'center', gap: 6, width: '100%',
            }}
          >
            ◈ Admin Dashboard
          </button>
        )}
        {onAgencyAdmin && (
          <button
            onClick={onAgencyAdmin}
            style={{
              marginTop: 6, background: 'rgba(196,153,34,.15)', border: '1px solid rgba(196,153,34,.3)',
              borderRadius: 6, color: 'var(--gold-400)', cursor: 'pointer',
              padding: '5px 10px', fontSize: 11, display: 'flex', alignItems: 'center', gap: 6, width: '100%',
            }}
          >
            👥 Admin
          </button>
        )}
        {onShowOnboarding && (
          <button
            onClick={onShowOnboarding}
            style={{
              marginTop: 6, background: 'none', border: '1px solid rgba(255,255,255,.1)',
              borderRadius: 6, color: 'rgba(255,255,255,.35)', cursor: 'pointer',
              padding: '5px 10px', fontSize: 11, display: 'flex', alignItems: 'center', gap: 6, width: '100%',
            }}
          >
            ◎ Setup Guide
          </button>
        )}
        {onSignOut && (
          <button
            onClick={onSignOut}
            style={{
              marginTop: 6, background: 'none', border: '1px solid rgba(255,255,255,.1)',
              borderRadius: 6, color: 'rgba(255,255,255,.4)', cursor: 'pointer',
              padding: '5px 10px', fontSize: 11, display: 'flex', alignItems: 'center', gap: 6, width: '100%',
            }}
          >
            ⎋ Sign Out
          </button>
        )}
      </div>
    </aside>
  );
}
